import type { Account } from "../models/Account";
import type { AccountPost } from "../models/AccountPost";

export function getBankInfoForTile({
  accountNumber,
  country,
  currency,
  iban,
  routing,
  pixKey,
}: Account | AccountPost) {
  const countryCode = typeof country === "object" ? country.id : country;

  if (currency.id === "GBP") {
    return [accountNumber, routing];
  }

  if (currency.id === "BRL" && countryCode === "BR" && pixKey) {
    return pixKey.value;
  }

  return iban;
}

export type BankInfoForTile = ReturnType<typeof getBankInfoForTile>;
